import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { BkgLogo } from "@/components/store/Logo";

export function Navbar({ onCartOpen }) {
  const { cartCount } = useStore();
  const links = [
    ["Collection", "#shop", "nav-collection-link"],
    ["Manifesto", "#manifesto", "nav-manifesto-link"],
    ["Admin", "/admin", "nav-admin-link"],
  ];

  return (
    <header className="fixed left-0 top-0 z-40 w-full border-b border-white/10 bg-black/60 backdrop-blur-xl" data-testid="main-navigation">
      <div className="grid h-20 grid-cols-2 items-center px-5 sm:grid-cols-3 lg:px-10">
        <nav className="hidden items-center gap-8 sm:flex">
          {links.slice(0, 2).map(([label, href, id]) => (
            <a key={label} data-testid={id} href={href} className="text-xs font-bold uppercase tracking-[0.24em] text-zinc-400 transition-colors hover:text-volt">
              {label}
            </a>
          ))}
        </nav>
        <BkgLogo className="justify-self-start sm:justify-self-center" />
        <div className="flex items-center justify-end gap-3">
          <Link to="/admin" data-testid="nav-admin-link" className="hidden text-xs font-bold uppercase tracking-[0.24em] text-zinc-400 transition-colors hover:text-volt sm:block">
            Admin
          </Link>
          <button data-testid="open-cart-button" onClick={onCartOpen} className="kinetic-button flex h-11 items-center gap-3 border border-white/15 px-4 text-xs font-bold uppercase tracking-[0.2em] transition-colors hover:text-black">
            <ShoppingBag size={16} />
            Cart
            <span data-testid="cart-count" className="grid h-6 w-6 place-items-center rounded-full bg-volt text-[11px] text-black">{cartCount}</span>
          </button>
        </div>
      </div>
    </header>
  );
}
